import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var cartListRoute = [{
  path: "cartList",
  name: "cartList",
  component: function component() {
    return import( /* webpackChunkName: "order-confirm" */"./cart-list.vue");
  }
}];